export default __webpack_public_path__ + "static/media/navigation-arrow2.f10276a4.webp";